import React from 'react';

export interface ListGroupProps extends React.HTMLAttributes<HTMLUListElement> {
  flush?: boolean;
}

export const ListGroup: React.FC<ListGroupProps> = ({ 
  className = '', 
  flush = false, 
  children, 
  ...props 
}) => {
  const baseClass = 'flex flex-col pl-0 mb-0 rounded border border-gray-200';
  const flushClass = flush ? 'rounded-none border-0' : '';
  
  return (
    <ul className={`list-group ${baseClass} ${flushClass} ${className}`} {...props}>
      {children}
    </ul>
  );
};

export interface ListGroupItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  active?: boolean;
  disabled?: boolean;
  tag?: React.ElementType;
}

export const ListGroupItem: React.FC<ListGroupItemProps> = ({ 
  className = '', 
  active = false, 
  disabled = false, 
  tag: Tag = 'li', 
  children, 
  ...props 
}) => {
  const baseClass = 'relative block px-4 py-3 bg-white border-b border-gray-200 last:border-b-0';
  const activeClass = active ? 'z-10 text-white bg-[var(--color-primary)] border-[var(--color-primary)]' : 'text-gray-800';
  const disabledClass = disabled ? 'text-gray-400 bg-gray-100 pointer-events-none' : '';
  
  return (
    <Tag className={`list-group-item ${baseClass} ${activeClass} ${disabledClass} ${className}`} {...props}>
      {children}
    </Tag>
  );
};
